import React from "react";

const LoadingCubes = () => {
    return (
        <div className="loading_container">
            <div className="header_loading fade-in"></div>
            <div className="bottom_loading fade-in">
                {Array.from({ length: 5 }).map((_, index) => (
                    <div key={index} className="bottom_loading_item"></div>
                ))}
            </div>
        </div>
    );
};

export default LoadingCubes;
